import { h, Component } from 'preact';

import { withContext } from '../../common/context';
import { FlexCenterStretched } from '../../utils/emotion';
import { Viewer } from './viewer/Viewer';
import Placeholder from '../Placeholder/Placeholder';
import { MediaSymbolTypes } from '../../typing/enums';
import Error from '../Error/Error';

import { ThreeWrapper } from './Three.styled';

class Three extends Component {
  state = {
    error: false,
    ready: false
  };

  componentDidMount() {
    this.viewer = new Viewer(this.wrap);
    const debugMode = this.props.context.config.selectDebug();

    const asset = this.props.context.cloudinary.getThreeUrl(
      this.props.publicId,
      this.props.transformation
    );

    this.viewer
      .loadModel(asset)
      .then(({ data, domElement }) => {
        if (debugMode) console.log('[Gallery Widget] 3D Model Loaded:', data);
        // HDR
        this.viewer.loadHdr(this.props.hdr || 'basic', this.props.skybox);
        // Shadows
        this.viewer.toggleShadows(this.props.shadows);
        // AR
        if (this.props.showAR) {
          this.viewer.loadARQR(
            this.props.context.config.selectConfig().cloudName,
            this.props.publicId
          );
        }
        // Alt text
        if (this.props.ariaLabel) {
          domElement.setAttribute('aria-label', this.props.ariaLabel);
        }
        this.setState({ ready: true });
      })
      .catch(e => {
        if (debugMode) console.error('[Gallery Widget] 3D Model Error:', e);
        this.setState({ error: true });
      });
  }

  componentWillUnmount() {
    this.viewer.cleanUp();
  }

  render(props) {
    return (
      <FlexCenterStretched relative>
        <ThreeWrapper
          innerRef={elem => (this.wrap = elem)}
          data-test="three-wrap"
          width={props.width}
          height={props.height}
        />
        {!this.state.error && !this.state.ready && (
          <FlexCenterStretched absolute>
            <Placeholder
              publicId={props.publicId}
              width={props.width}
              height={props.height}
              mediaType={MediaSymbolTypes.SPIN}
              transformation={this.props.transformation}
            />
          </FlexCenterStretched>
        )}
        {this.state.error && (
          <FlexCenterStretched absolute>
            <Error width={props.width} />
          </FlexCenterStretched>
        )}
      </FlexCenterStretched>
    );
  }
}

export default withContext(Three);
